import ScreenLayout from "@/components/layout/screen-layout";
import { Button } from "@/components/ui/button";
import { BannerBgVector, LogoDvekrestWhite } from "@/lib/images";
import { cn } from "@/lib/utils";
import Image from "next/image";
import Link from "next/link";

type BannerSectionProps = {
  heading: string;
  sub_heading: string;
  button_text: string;
  button_link: string;
  outerClassName?: string;
};

function BannerSection({
  heading,
  sub_heading,
  button_text,
  button_link,
  outerClassName,
}: BannerSectionProps) {
  const outerBg = outerClassName ?? "bg-[#F7F8FC]";

  return (
    <div className={cn(outerBg)}>
      <ScreenLayout outerClassName="bg-transparent" className="">
        <div className="hidden lg:block w-full py-8 lg:py-16 px-0">
          <div
            className="relative bg-[#001F8F] overflow-hidden flex justify-center items-center rounded-[20px] py-12 xl:py-16  px-4 sm:px-12 text-center lg:min-h-108"
          // style={{
          //   background:
          //     "radial-gradient(0% 182.18% at 50% 50%, #000929 0%, #001F8F 100%)",
          // }}
          >
            {/* Vector Background Image */}
            <Image
              src={BannerBgVector}
              alt="Contact Us"
              className="absolute inset-0 h-full w-full object-contain object-left z-0"
            />
            {/* Content */}
            <div className="relative z-10 flex flex-col justify-center items-center text-white gap-4 max-w-4xl">
              <Image
                src={LogoDvekrestWhite}
                alt="Logo"
                className="w-auto h-10 sm:h-12 mb-2"
              />
              <h1 className="text-2xl sm:text-3xl lg:text-5xl font-medium leading-snug">
                {heading}
              </h1>
              <p className="text-sm sm:text-base font-medium opacity-70 mb-2">
                {sub_heading}
              </p>
              <Link href={button_link}>
                <Button
                  variant="secondary"
                  size="sm"
                  className="text-custom-blue text-sm sm:text-base  rounded-full px-6 h-12"
                >
                  {button_text}
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </ScreenLayout>
      <div className="lg:hidden w-full pb-13 px-4 sm:px-6">
        <div
          className="relative overflow-hidden flex bg-[#001F8F] justify-center items-center py-12 md:min-h-108.5 text-center px-2 rounded-2xl mx-2"
        // style={{
        //   background:
        //     "radial-gradient(50% 182.18% at 50% 50%, #000929 0%, #001F8F 100%)",
        // }}
        >
          <Image
            src={BannerBgVector}
            alt="Contact Us"
            className="absolute inset-0 w-full h-full object-contain object-center z-0"
          />
          {/* Content */}
          <div className="relative z-10 flex flex-col justify-center items-center text-white gap-4 max-w-3xl px-4 sm:px-6">
            <Image
              src={LogoDvekrestWhite}
              alt="Logo"
              className=" w-auto h-10 sm:h-12 mb-2"
            />
            <h1 className="text-2xl sm:text-3xl lg:text-5xl font-medium leading-snug ">
              {heading}
            </h1>
            <p className="text-sm sm:text-base font-medium opacity-70 mb-2">
              {sub_heading}
            </p>
            <Link href={button_link}>
              <Button
                variant="secondary"
                size="sm"
                className="  font-semibold rounded-full "
              >
                {button_text}
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BannerSection;
